import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ImSchemaFileDto} from "../../../../model/dto/entity/im-schema-file.dto";
import {ObjectBaseModeComponent} from "../../../../../../core/shared/object/mvs-object-base/object-base-mode.component";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {NavigationItem} from "../../../../../../core/shared/dto/navigation/navigation-item";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";


@Component({
    selector: 'hg-gdv-partner-base',
    template: '',
    standalone: false
})
export class ImSchemaBaseComponent extends ObjectBaseModeComponent implements OnInit {

    basicWidgetData: WidgetData;
    @Input() dto: ImSchemaFileDto;

    busy: boolean;

    navigationItems: NavigationItem[] = [
        {
            label: 'system',
            action: 'system',
            icon: 'fa-regular fa-info-circle',
            tooltip: 'System',
            toggleable: false,
            default: true
        },
        {
            label: 'test',
            action: 'test',
            icon: 'fa-regular fa-vials',
            tooltip: 'Test',
            toggleable: false,
            default: false
        },
    ];


    constructor(
        protected route: ActivatedRoute) {
        super(route);
    }

    ngOnInit(): void {

        if (this.navigationItems?.length) {
            this.activeNavigationItem = this.navigationItems.find(item => item.default == true);
            this.onNavigationItems.emit(this.navigationItems);
        }


        super.ngOnInit();
        this.refreshWidgets();
    }

    refreshWidgets() {
        this.basicWidgetData = WidgetFactory.createWidgetEntityData(
            'im.schema.file.basic.widget.data',
            'Im Schema File',
            'im.ImSchemaFile',
            this.objectIdentifier.objectId
        );
    }





}
